import { createAction } from "@ngrx/store";

export const initializedWithError = createAction(
  'App.InitializedWithError'
);
